var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "hidden md:block absolute bottom-0 right-0 w-full h-[607px]",
    style: 'background: url(/img/diamonds-1.svg) no-repeat center center; background-size: cover;'
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }